const pad = function(num) {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
};
/**
 * Formats a date according to ISO format
 * and adds timezone at the end
 * @param {Date} date
 * @returns {string}
 */ const toISOString = (date)=>{
    const tzo = -date.getTimezoneOffset();
    const dif = tzo >= 0 ? '+' : '-';
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds()) + '.' + pad(date.getMilliseconds()) + dif + pad(tzo / 60) + ':' + pad(tzo % 60);
};

export { toISOString };
//# sourceMappingURL=format-to-iso-string.js.map
